import { ReactComponent as Arrow } from './arrow.svg';

export default Arrow; // it is in use on /component/impressionBox
